import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';
import { UserState } from '../../../statemanagement/user.state';
import { MyRouter } from '../../../common/services/router.service';
import { NotificationsController } from '../../controllers/notifications/notifications.controller';
import { SettingsState } from '../../../statemanagement/settings.state';

export const rightsGuard = (
    activatedRouteSnapshot: ActivatedRouteSnapshot
) => {
    const router = inject(MyRouter);
    const store = inject(Store);
    const notificationsController = inject(NotificationsController);

    return store.pipe(
        select('settings'),
        filter((settings: SettingsState) => settings.ready),
        switchMap(() => store.pipe(select('user'))),
        map((user: UserState) => user.rights),
        map((rights: string[]) => {
            if (rights.indexOf(activatedRouteSnapshot.data.right) !== -1) {
                return true;
            } else {
                router.navigateWithCorporateClient(['']);
                notificationsController.create({message: 'NOTIFICATIONS.NOT_AUTHORIZED_ACCESS_PAGE'});
                return false;
            }
        }));
}
